"use client";

import React, { useEffect, useState } from "react";
import { BreadcrumbView } from "../BreadCrumb";
import { useSelector } from "react-redux";
import { RootState } from "@/src/redux/store";
import { ChevronDown, ChevronUp } from "lucide-react";
import { motion } from "framer-motion";
import { findCategoryBySlug } from "@/src/Seo/metaData/categoryMeta";

const CategoryHeader = ({ slugList }: { slugList: string[] }) => {
  const categories = useSelector(
    (state: RootState) => state.category.productCategories,
  );

  const [currentCategory, setCurrentCategory] = useState<any | null>();

  const [showDescription, setShowDescription] = useState<boolean>(true);

  // const findCategoryBySlug = () => {
  //   let current = categories; // Start with top-level categories
  //   let match = null;

  //   for (const slug of slugList) {
  //     match = current?.find((cat) => cat?.slug === slug);
  //     if (match) {
  //       current = match.children; // Move to the next level (children)
  //     } else {
  //       return null; // Return null if no match is found
  //     }
  //   }

  //   return match; // Return the final matched category
  // };

  useEffect(() => {
    const fetchData = () => {
      const data = findCategoryBySlug({
        categories: categories,
        slugList: slugList,
      });
      setCurrentCategory(data);
    };
    fetchData();
  }, [categories]);

  const handleShowDescription = () => {
    setShowDescription(!showDescription);
  };

  return (
    <div className="pb-6 pt-4 shadow-md">
      <div className="px-4 md:px-8 lg:px-16 xl:px-32 2xl:px-64">
        <BreadcrumbView />

        {/* {JSON.stringify(currentCategory)} */}

        <div className="mt-10 flex flex-col items-center justify-center">
          <div
            className="flex items-center justify-center gap-2"
            onClick={handleShowDescription}
          >
            <div className="text-2xl font-semibold">
              {currentCategory?.name}
            </div>

            {showDescription ? <ChevronUp /> : <ChevronDown />}
          </div>

          <motion.div
            animate={{
              x: showDescription ? 0 : "-100%", // Slide in from the left when `showDescription` is true, slide out when false
              opacity: showDescription ? 1 : 0, // Fade in when `showDescription` is true, fade out when false
            }}
            initial={{ x: "-100%", opacity: 0 }} // Start with the description hidden to the left and invisible
            exit={{ x: "-100%", opacity: 0 }} // When the element is removed, slide out and fade out
            transition={{
              type: "spring", // Smooth, bouncy transition
              stiffness: 300, // Controls the stiffness of the spring
              damping: 30, // Controls the damping (how "smooth" the transition is)
              duration: 0.5, // Duration of the animation
            }}
            className="mb-5 mt-3 flex sm:px-[10%] md:mt-5 md:px-[15%]"
            style={{ display: showDescription ? "block" : "none" }} // Control the display based on the state
          >
            <div className="text-center text-sm font-light leading-7 tracking-wider md:text-[15px]">
              {currentCategory?.description}
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default CategoryHeader;
